import { useState, useEffect } from "react";

// ui
import {
  Button,
  Typography,
  Modal,
  Box,
  TextField,
  Paper,
  Alert,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Checkbox,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import { styled } from "@mui/system";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";

const CustomTextField = styled(TextField)({
  "& .MuiInputBase-input": {
    fontSize: "12px",
    height: "12px", // ここでフォントサイズを指定
  },
});
CustomTextField.defaultProps = {
  autoComplete: "off",
};

interface GetXLSXContractModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  getXLSXStatus: {
    status: "none" | "open" | "getting" | "result" | "loading" | "error";
    message: string;
    contract_state: string;
    sale_company_id: number | null;
    sale_company_name: string;
    all_company: boolean;
    product_id: number | null;
    product_name: string;
    all_product: boolean;
    post_start_year: string;
    post_start_month: string;
    post_end_year: string;
    post_end_month: string;
    post_all_year: boolean;
    apply_start_year: string;
    apply_start_month: string;
    apply_end_year: string;
    apply_end_month: string;
    apply_all_year: boolean;
    opening_start_year: string;
    opening_start_month: string;
    opening_end_year: string;
    opening_end_month: string;
    opening_all_year: boolean;
    cancell_start_year: string;
    cancell_start_month: string;
    cancell_end_year: string;
    cancell_end_month: string;
    cancell_all_year: boolean;
  };
  setGetXLSXStatus: (getXLSXStatus: {
    status: "none" | "open" | "getting" | "result" | "loading" | "error";
    message: string;
    contract_state: string;
    sale_company_id: number | null;
    sale_company_name: string;
    all_company: boolean;
    product_id: number | null;
    product_name: string;
    all_product: boolean;
    post_start_year: string;
    post_start_month: string;
    post_end_year: string;
    post_end_month: string;
    post_all_year: boolean;
    apply_start_year: string;
    apply_start_month: string;
    apply_end_year: string;
    apply_end_month: string;
    apply_all_year: boolean;
    opening_start_year: string;
    opening_start_month: string;
    opening_end_year: string;
    opening_end_month: string;
    opening_all_year: boolean;
    cancell_start_year: string;
    cancell_start_month: string;
    cancell_end_year: string;
    cancell_end_month: string;
    cancell_all_year: boolean;
  }) => void;
  getXLSXFunc: () => void;
  firstYear: number;
  thisYear: number;
  thisMonth: number;
  lastYear: number;
  lastMonth: number;
  companyList: { id: number; sale_company_name: string }[];
  productList: {
    id: number;
    high_rank_company_id: number;
    product_name: string;
    high_rank_company_name: string;
  }[];
}

export function GetXLSXContractModal(props: GetXLSXContractModalProps) {
  const {
    onModal,
    swCloseModal,
    getXLSXStatus,
    setGetXLSXStatus,
    getXLSXFunc,
    firstYear,
    thisYear,
    thisMonth,
    lastYear,
    lastMonth,
    companyList,
    productList,
  } = props;

  const loginUser = useAtomValue(AppAtoms.loginUser);

  const createMonthList = () => {
    let monthList = [];
    for (let i = 1; i <= 12; i++) {
      monthList.push(i.toString());
    }
    return monthList;
  };
  const createYearList = () => {
    let yearList = [];
    for (let i = firstYear; i <= thisYear; i++) {
      yearList.push(i.toString());
    }
    return yearList;
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const [postCSVProductName, setPostCSVProductName] = useState<string>("");
  const autocompleteProductList: string[] = productList.map((product) => {
    return product.high_rank_company_name === "-"
      ? product.product_name
      : product.high_rank_company_name + "/" + product.product_name;
  });
  useEffect(() => {
    let productID: null | number = null;
    let productName: string = "";
    productList.map((product) => {
      const _postCSVProductName =
        product.high_rank_company_name === "-"
          ? product.product_name
          : product.high_rank_company_name + "/" + product.product_name;
      if (postCSVProductName === _postCSVProductName) {
        productID = product.id;
        productName = product.product_name;
      }
    });
    if (productID) {
      setGetXLSXStatus({
        ...getXLSXStatus,
        product_id: productID,
        product_name: productName,
      });
    }
  }, [postCSVProductName]);

  const [postCSVSaleCompanyName, setPostCSVSaleCompanyName] =
    useState<string>("");
  const autocompleteSaleCompanyList: string[] = companyList.map(
    (saleCompany) => {
      return saleCompany.sale_company_name;
    }
  );
  useEffect(() => {
    let saleCompanyID: null | number = null;
    let saleCompanyName: string = "";
    companyList.map((saleCompany) => {
      if (postCSVSaleCompanyName === saleCompany.sale_company_name) {
        saleCompanyID = saleCompany.id;
        saleCompanyName = saleCompany.sale_company_name;
      }
    });
    if (saleCompanyID) {
      setGetXLSXStatus({
        ...getXLSXStatus,
        sale_company_id: saleCompanyID,
        sale_company_name: saleCompanyName,
      });
    }
  }, [postCSVSaleCompanyName]);

  function closeModal() {
    setPostCSVProductName("");
    setPostCSVSaleCompanyName("");
    swCloseModal();
  }
  return (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          エントリー一覧出力
        </Typography>
        {getXLSXStatus.status === "open" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Paper elevation={1}>
              <Box sx={{ maxHeight: "calc(70vh - 80px)", overflowY: "auto" }}>
                <Box key={"paymentElsxProduct"} sx={{ margin: "30px 0px" }}>
                  <FormControl
                    sx={{
                      marginLeft: "30px",
                      marginTop: "10px",
                      width: "82px",
                    }}
                  >
                    ステータス
                  </FormControl>
                  <FormControl sx={{ width: "520px", marginLeft: "120px" }}>
                    <CustomTextField
                      id="textFieldId"
                      value={getXLSXStatus.contract_state}
                      size="small"
                      onChange={(e) =>
                        setGetXLSXStatus({
                          ...getXLSXStatus,
                          contract_state: e.target.value,
                        })
                      }
                      sx={{ width: "calc(100% - 10px)", margin: "10px 5px " }}
                    />
                    <FormHelperText
                      id="serch-name"
                      sx={{
                        width: "calc(100% - 10px)",
                        textAlign: "right",
                        marginTop: "-8px",
                        minHeight: "25px",
                      }}
                    >
                      ※部分一致
                    </FormHelperText>
                  </FormControl>
                </Box>
                <Box key={"paymentElsxProduct"} sx={{ margin: "30px 0px" }}>
                  <FormControl
                    sx={{
                      marginLeft: "30px",
                      marginTop: "10px",
                      width: "635px",
                    }}
                  >
                    商材
                  </FormControl>
                  全商材
                  <Checkbox
                    checked={getXLSXStatus.all_product}
                    onClick={() => {
                      setGetXLSXStatus({
                        ...getXLSXStatus,
                        all_product: !getXLSXStatus.all_product,
                      });
                    }}
                  />
                  {getXLSXStatus.all_product ? null : (
                    <FormControl sx={{ width: "520px", marginLeft: "230px" }}>
                      <Autocomplete
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                        clearIcon={null}
                        options={autocompleteProductList}
                        value={postCSVProductName}
                        onChange={(event: any, newValue: string | null) => {
                          if (newValue) {
                            setPostCSVProductName(newValue);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            value={postCSVProductName}
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "16px",
                                height: "32px",
                              },
                            }}
                            {...params}
                          />
                        )}
                      />
                    </FormControl>
                  )}
                </Box>
                {loginUser?.authority !== "パートナー" &&
                loginUser?.authority !== "営業アカウント" ? (
                  <Box
                    key={"paymentElsxSaleCompany"}
                    sx={{ margin: "30px 0px" }}
                  >
                    <FormControl
                      sx={{
                        marginLeft: "30px",
                        marginTop: "10px",
                        width: "585px",
                      }}
                    >
                      パートナー
                    </FormControl>
                    全パートナー
                    <Checkbox
                      checked={getXLSXStatus.all_company}
                      onClick={() => {
                        setGetXLSXStatus({
                          ...getXLSXStatus,
                          all_company: !getXLSXStatus.all_company,
                        });
                      }}
                    />
                    {getXLSXStatus.all_company ? null : (
                      <FormControl sx={{ width: "520px", marginLeft: "230px" }}>
                        <Autocomplete
                          sx={{
                            height: "30px",
                            textAlign: "end",
                          }}
                          clearIcon={null}
                          options={autocompleteSaleCompanyList}
                          value={postCSVSaleCompanyName}
                          onChange={(event: any, newValue: string | null) => {
                            if (newValue) {
                              setPostCSVSaleCompanyName(newValue);
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              value={postCSVSaleCompanyName}
                              sx={{
                                "& .MuiInputBase-root": {
                                  fontSize: "16px",
                                  height: "32px",
                                },
                              }}
                              {...params}
                            />
                          )}
                        />
                      </FormControl>
                    )}
                  </Box>
                ) : null}
                <Box
                  key={"post_paymentElsxBoxYear"}
                  sx={{ margin: "30px 0px" }}
                >
                  <FormControl
                    sx={{
                      marginLeft: "30px",
                      marginTop: "10px",
                      width: "600px",
                    }}
                  >
                    システム登録日
                  </FormControl>
                  検索しない
                  <Checkbox
                    checked={getXLSXStatus.post_all_year}
                    onClick={() => {
                      setGetXLSXStatus({
                        ...getXLSXStatus,
                        post_all_year: !getXLSXStatus.post_all_year,
                      });
                    }}
                  />
                </Box>
                {getXLSXStatus.post_all_year ? null : (
                  <Box
                    key={"post_paymentElsxBoxYear2"}
                    sx={{ margin: "15px 0px" }}
                  >
                    <FormControl sx={{ width: "150px", marginLeft: "130px" }}>
                      <InputLabel id="serch-input-label">年</InputLabel>
                      <Select
                        disabled={getXLSXStatus.post_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.post_start_year}
                        label={"年"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            post_start_year: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createYearList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "80px", marginLeft: "30px" }}>
                      <InputLabel id="serch-input-label">月</InputLabel>
                      <Select
                        disabled={getXLSXStatus.post_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.post_start_month}
                        label={"月"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            post_start_month: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createMonthList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "50px", marginLeft: "45px" }}>
                      ~
                    </FormControl>
                    <FormControl sx={{ width: "150px" }}>
                      <InputLabel id="serch-input-label">年</InputLabel>
                      <Select
                        disabled={getXLSXStatus.post_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.post_end_year}
                        label={"年"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            post_end_year: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createYearList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "80px", marginLeft: "30px" }}>
                      <InputLabel id="serch-input-label">月</InputLabel>
                      <Select
                        disabled={getXLSXStatus.post_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.post_end_month}
                        label={"月"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            post_end_month: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createMonthList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Box>
                )}
                <Box
                  key={"apply_paymentElsxBoxYear"}
                  sx={{ margin: "30px 0px" }}
                >
                  <FormControl
                    sx={{
                      marginLeft: "30px",
                      marginTop: "10px",
                      width: "600px",
                    }}
                  >
                    申込日
                  </FormControl>
                  検索しない
                  <Checkbox
                    checked={getXLSXStatus.apply_all_year}
                    onClick={() => {
                      setGetXLSXStatus({
                        ...getXLSXStatus,
                        apply_all_year: !getXLSXStatus.apply_all_year,
                      });
                    }}
                  />
                </Box>
                {getXLSXStatus.apply_all_year ? null : (
                  <Box
                    key={"apply_paymentElsxBoxYear2"}
                    sx={{ margin: "15px 0px" }}
                  >
                    <FormControl sx={{ width: "150px", marginLeft: "130px" }}>
                      <InputLabel id="serch-input-label">年</InputLabel>
                      <Select
                        disabled={getXLSXStatus.apply_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.apply_start_year}
                        label={"年"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            apply_start_year: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createYearList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "80px", marginLeft: "30px" }}>
                      <InputLabel id="serch-input-label">月</InputLabel>
                      <Select
                        disabled={getXLSXStatus.apply_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.apply_start_month}
                        label={"月"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            apply_start_month: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createMonthList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "50px", marginLeft: "45px" }}>
                      ~
                    </FormControl>
                    <FormControl sx={{ width: "150px" }}>
                      <InputLabel id="serch-input-label">年</InputLabel>
                      <Select
                        disabled={getXLSXStatus.apply_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.apply_end_year}
                        label={"年"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            apply_end_year: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createYearList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "80px", marginLeft: "30px" }}>
                      <InputLabel id="serch-input-label">月</InputLabel>
                      <Select
                        disabled={getXLSXStatus.apply_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.apply_end_month}
                        label={"月"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            apply_end_month: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createMonthList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Box>
                )}
                <Box
                  key={"opening_paymentElsxBoxYear"}
                  sx={{ margin: "30px 0px" }}
                >
                  <FormControl
                    sx={{
                      marginLeft: "30px",
                      marginTop: "10px",
                      width: "600px",
                    }}
                  >
                    開通日
                  </FormControl>
                  検索しない
                  <Checkbox
                    checked={getXLSXStatus.opening_all_year}
                    onClick={() => {
                      setGetXLSXStatus({
                        ...getXLSXStatus,
                        opening_all_year: !getXLSXStatus.opening_all_year,
                      });
                    }}
                  />
                </Box>
                {getXLSXStatus.opening_all_year ? null : (
                  <Box
                    key={"opening_paymentElsxBoxYear2"}
                    sx={{ margin: "15px 0px" }}
                  >
                    <FormControl sx={{ width: "150px", marginLeft: "130px" }}>
                      <InputLabel id="serch-input-label">年</InputLabel>
                      <Select
                        disabled={getXLSXStatus.opening_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.opening_start_year}
                        label={"年"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            opening_start_year: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createYearList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "80px", marginLeft: "30px" }}>
                      <InputLabel id="serch-input-label">月</InputLabel>
                      <Select
                        disabled={getXLSXStatus.opening_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.opening_start_month}
                        label={"月"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            opening_start_month: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createMonthList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "50px", marginLeft: "45px" }}>
                      ~
                    </FormControl>
                    <FormControl sx={{ width: "150px" }}>
                      <InputLabel id="serch-input-label">年</InputLabel>
                      <Select
                        disabled={getXLSXStatus.opening_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.opening_end_year}
                        label={"年"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            opening_end_year: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createYearList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "80px", marginLeft: "30px" }}>
                      <InputLabel id="serch-input-label">月</InputLabel>
                      <Select
                        disabled={getXLSXStatus.opening_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.opening_end_month}
                        label={"月"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            opening_end_month: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createMonthList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Box>
                )}
                <Box
                  key={"cancell_paymentElsxBoxYear"}
                  sx={{ margin: "30px 0px" }}
                >
                  <FormControl
                    sx={{
                      marginLeft: "30px",
                      marginTop: "10px",
                      width: "600px",
                    }}
                  >
                    解約日
                  </FormControl>
                  検索しない
                  <Checkbox
                    checked={getXLSXStatus.cancell_all_year}
                    onClick={() => {
                      setGetXLSXStatus({
                        ...getXLSXStatus,
                        cancell_all_year: !getXLSXStatus.cancell_all_year,
                      });
                    }}
                  />
                </Box>
                {getXLSXStatus.cancell_all_year ? null : (
                  <Box
                    key={"cancell_paymentElsxBoxYear2"}
                    sx={{ margin: "15px 0px" }}
                  >
                    <FormControl sx={{ width: "150px", marginLeft: "130px" }}>
                      <InputLabel id="serch-input-label">年</InputLabel>
                      <Select
                        disabled={getXLSXStatus.cancell_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.cancell_start_year}
                        label={"年"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            cancell_start_year: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createYearList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "80px", marginLeft: "30px" }}>
                      <InputLabel id="serch-input-label">月</InputLabel>
                      <Select
                        disabled={getXLSXStatus.cancell_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.cancell_start_month}
                        label={"月"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            cancell_start_month: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createMonthList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "50px", marginLeft: "45px" }}>
                      ~
                    </FormControl>
                    <FormControl sx={{ width: "150px" }}>
                      <InputLabel id="serch-input-label">年</InputLabel>
                      <Select
                        disabled={getXLSXStatus.cancell_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.cancell_end_year}
                        label={"年"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            cancell_end_year: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createYearList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "80px", marginLeft: "30px" }}>
                      <InputLabel id="serch-input-label">月</InputLabel>
                      <Select
                        disabled={getXLSXStatus.cancell_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.cancell_end_month}
                        label={"月"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            cancell_end_month: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createMonthList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Box>
                )}
              </Box>
            </Paper>
            <Box>
              <Button
                disabled={
                  (loginUser?.authority !== "パートナー" &&
                    loginUser?.authority !== "営業アカウント" &&
                    getXLSXStatus.sale_company_id === null &&
                    !getXLSXStatus.all_company) ||
                  (getXLSXStatus.product_id === null &&
                    !getXLSXStatus.all_product)
                }
                variant="outlined"
                style={{
                  marginTop: "15px",
                  height: "40px",
                  position: "absolute",
                  right: "205px",
                  width: "200px",
                  fontSize: "20px",
                }}
                onClick={() => {
                  getXLSXFunc();
                  setGetXLSXStatus({
                    ...getXLSXStatus,
                    status: "loading",
                  });
                }}
              >
                <Box className="m-plus-rounded-1c-modal">一覧出力</Box>
                <FileDownloadIcon
                  sx={{ marginLeft: "6px" }}
                  fontSize="medium"
                />
              </Button>
              <Button
                variant="outlined"
                style={{
                  marginTop: "15px",
                  height: "40px",
                  position: "absolute",
                  right: "35px",
                  width: "160px",
                  fontSize: "20px",
                }}
                onClick={closeModal}
              >
                <Box className="m-plus-rounded-1c-modal">キャンセル</Box>
              </Button>
            </Box>
          </Typography>
        ) : getXLSXStatus.status === "loading" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Box sx={{ textAlign: "center" }}>契約一覧作成準備中</Box>
          </Typography>
        ) : getXLSXStatus.status === "getting" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Box sx={{ textAlign: "center" }}>{getXLSXStatus.message}</Box>
          </Typography>
        ) : getXLSXStatus.status === "error" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Alert severity="error">
              <Box>エントリー一覧出力に失敗しました。</Box>
            </Alert>
            <Button
              variant="outlined"
              style={{
                marginTop: "15px",
                height: "40px",
                position: "absolute",
                right: "45px",
                width: "160px",
                fontSize: "20px",
              }}
              onClick={() =>
                setGetXLSXStatus({
                  status: "open",
                  message: "",
                  contract_state: "",
                  sale_company_id: null,
                  sale_company_name: "",
                  all_company: false,
                  product_id: null,
                  product_name: "",
                  all_product: false,
                  post_start_year: lastYear.toString(),
                  post_start_month: lastMonth.toString(),
                  post_end_year: thisYear.toString(),
                  post_end_month: thisMonth.toString(),
                  post_all_year: false,
                  apply_start_year: lastYear.toString(),
                  apply_start_month: lastMonth.toString(),
                  apply_end_year: thisYear.toString(),
                  apply_end_month: thisMonth.toString(),
                  apply_all_year: true,
                  opening_start_year: lastYear.toString(),
                  opening_start_month: lastMonth.toString(),
                  opening_end_year: thisYear.toString(),
                  opening_end_month: thisMonth.toString(),
                  opening_all_year: true,
                  cancell_start_year: lastYear.toString(),
                  cancell_start_month: lastMonth.toString(),
                  cancell_end_year: thisYear.toString(),
                  cancell_end_month: thisMonth.toString(),
                  cancell_all_year: true,
                })
              }
            >
              戻る
            </Button>
          </Typography>
        ) : getXLSXStatus.status === "result" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Box>{getXLSXStatus.message}</Box>
            <Button
              variant="outlined"
              style={{
                marginTop: "15px",
                height: "40px",
                position: "absolute",
                right: "45px",
                width: "160px",
                fontSize: "20px",
              }}
              onClick={closeModal}
            >
              閉じる
            </Button>
          </Typography>
        ) : null}
      </Box>
    </Modal>
  );
}
